"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupServices = exports.locale = exports.http = exports.host = exports.configData = exports.analytics = exports.Parsers = void 0;
var _analytics = require("./analytics");
var _host = require("./host");
var _locale = _interopRequireDefault(require("./locale"));
var _http = require("./http");
var _tenants = require("./tenants");
var _parserMap = require("../utils/parsers/parserMap");
var _WindowAPIHelper = require("./WindowAPIHelper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let analytics;
exports.analytics = analytics;
let host;
exports.host = host;
let locale;
exports.locale = locale;
let http;
exports.http = http;
let configData;
exports.configData = configData;
let Parsers;
exports.Parsers = Parsers;
const setupServices = _ref => {
  var _TENANT_SERVICE$tenan, _TENANT_SERVICE$tenan2;
  let {
    config,
    i18n,
    marketingId,
    addToCartCallback,
    openGuidedSellingModal,
    setMetadata,
    setFlags,
    setSkippedQuestionIds
  } = _ref;
  const {
    tenant,
    api,
    localOptions,
    market
  } = config;

  // Analytics Service
  const analyticsServiceClass = ((_TENANT_SERVICE$tenan = _tenants.TENANT_SERVICE[tenant]) === null || _TENANT_SERVICE$tenan === void 0 ? void 0 : _TENANT_SERVICE$tenan.analytics) || _analytics.AnalyticsService;
  const analyticsService = new analyticsServiceClass(config);
  if (!analytics) exports.analytics = analytics = analyticsService;

  // Host Service
  const hostServiceClass = ((_TENANT_SERVICE$tenan2 = _tenants.TENANT_SERVICE[tenant]) === null || _TENANT_SERVICE$tenan2 === void 0 ? void 0 : _TENANT_SERVICE$tenan2.host) || _host.HostService;
  exports.host = host = new hostServiceClass({
    marketingId,
    addToCartCallback,
    config,
    openGuidedSellingModal
  });

  // Locale Service
  exports.locale = locale = new _locale.default({
    i18n,
    options: {
      ...localOptions,
      market: market
    }
  });

  // HttpService
  exports.http = http = (0, _http.getHttpServiceInstance)({
    api,
    tenant
  });
  const {
    windowAPI: windowAPIConfig
  } = config;
  (0, _WindowAPIHelper.getWindowServiceInstance)({
    ...windowAPIConfig,
    setMetadata,
    setFlags,
    setSkippedQuestionIds,
    openGuidedSellingModal,
    config
  });
  // config
  exports.configData = configData = config;
  exports.Parsers = Parsers = (0, _parserMap.Parsers)(tenant);
};
exports.setupServices = setupServices;